import React, { useEffect, useRef } from "react";
import { getStageMessage } from "./getStageMessage";
import "./meetingdetails.css";
import GetImage from "../../components/getimage/Getimage";
import getMeetingTime from "./utility/getMeetingTime";
import { getDateLabel } from "./utility/getDateLabel";
import Micicon from "../../assets/mic.png"
import Tint from "../../utility/ImageTint/Tint"
const Detailssection = ({ details, userID,meetingInfo ,bottomHeight}) => {
const containerRef = useRef(null);
useEffect(() => {
  if (!details?.length) return null;
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [details]);
  if (!details?.length) return null;


const groupedData = details.reduce((acc, item) => {
  const label = getDateLabel(item.logtime);

  if (!acc[label]) {
    acc[label] = [];
  }

  acc[label].push(item);
  return acc;
}, {});
const circle1 = {
  width: "24px",
  height: "24px",
  borderRadius: "50%",
  backgroundColor: "#60a5fa",
  border: "2px solid white",
  zIndex: 1
};

const circle2 = {
  width: "24px",
  height: "24px",
  borderRadius: "50%",
  backgroundColor: "#f87171",
  border: "2px solid white",
  marginLeft: "-11px",
  zIndex: 2
};

const empIds = meetingInfo?.empids?.split(",") || [];
  return (
    <div  ref={containerRef} style={{height:"78vh" , overflowY:"auto" , paddingBottom: meetingInfo.stage == 2 ? "100px" : 150+bottomHeight }}>
     {meetingInfo?.attendees != -1 && meetingInfo?.attendance != -1 && (
  <div
    style={{
      position: "sticky",
      top: 6,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      gap: "6px", 
      padding: "4px 0",
      zIndex: 10,
    }}
  >
    <div
  style={{
    backgroundColor: "#e6e7eb",
    color: "#4b5563",
    padding: "4px 18px",
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    gap: "6px"
  }}
>
  
  <div style={{ display: "flex", alignItems: "center" }}>
  
  {empIds[0] && (
    <div style={circle1}>
      <GetImage imgID={empIds[0]} width="100%" height="100%" />
    </div>
  )}

  {empIds[1] && (
    <div style={{ ...circle2, overflow:"hidden" }}>
      <GetImage imgID={empIds[1]} width="100%" height="100%" />
    </div>
  )}
{/* 
  {empIds.length > 2 && (
    <div style={countCircle}>
      +{empIds.length - 2}
    </div>
  )} */}

</div>
  <span style={{ fontWeight: 600, fontSize: "16px" }}>
    {meetingInfo?.attendance}
  </span>
  <span style={{ fontWeight: 500, fontSize: "16px"}}>
    / {meetingInfo?.attendees}
  </span>
</div>
    


  </div>
)}
    <div style={{marginTop:"20px" ,}}>
  {Object.keys(groupedData).map((dateLabel) => (
    <div key={dateLabel}>
      <div  style={{display:"flex", justifyContent:"center" ,marginBottom:"10px", marginTop:"10px"}}>
        <p className="date-header" >
        {dateLabel}
            </p>
      </div>
      {groupedData[dateLabel].map((item, index) => {
        const isLast = index == groupedData[dateLabel].length - 1;
        const stageData = getStageMessage({
          actionType: item?.actiontype,
          actionByEmpID: item?.actionbyempid,
          actionByEmpName: item?.actionbyempname,
          createdByEmpID: meetingInfo?.createdbyempid,
          createdByEmpName: meetingInfo?.createdbyempname,
          hostedByEmpID: meetingInfo?.hostempid,
          hostedByEmpName: meetingInfo?.hostempname,
          
          userID,
          data: item?.data,
          details:meetingInfo
        });
// console.log(stageData,"stagedata")
        return (
          <div key={index} className="detailsitem">

            <div className="image-row" style={{display:"flex", justifyContent:"center"}}>
              {stageData.leftImage && (
                <div className="isimg">
                <GetImage
                  imgID={stageData.leftImage}
                  width="40px"
                  height="40px"
                />
                </div>
              )}
{
  stageData.icon && <img src={Micicon} style={{width:"20px" , filter:Tint("#29b6f6")}}/>
}
              {stageData.showRight &&
                stageData.rightImage &&
                stageData.rightImage != stageData.leftImage && (
                  <div className="isimg">
 <GetImage
                    imgID={stageData.rightImage}
                    width="40px"
                    height="40px"
                  />
                    </div>
                 
                )}
            </div>

<div  style={{
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  }}>
 <div
  style={{
    height: "15px",
    borderRight: "2px solid #c3c7cd",
  }}
/>
</div>

<div
  style={{
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  }}
>

  <div
    style={{
      color: "#5c5066",
      fontWeight: "500",
      textAlign: "center",
      zIndex: 1,
      // background: "white",
      padding: "0 8px",
    }}
    dangerouslySetInnerHTML={{ __html: stageData.message }}
  />

</div>

<div
    style={{
      // position: "absolute",
      right: 0,
      color: "#9ca3af",
      fontSize: "12px",
      fontWeight:700,
      whiteSpace: "nowrap",
      // background: "white",
      padding: "0 5px",
    }}
  >
    {getMeetingTime(item.logtime.date)}
  </div>

  <div  style={{
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  }}>
    {
      !isLast && <div
  style={{
    
    marginTop:"4px",
    height: "30px",
    borderRight: "2px solid #c3c7cd",
  }}
/>
    }

</div>
          {item.actiontype == 3  && (
  <div
  className="summarytest"
    dangerouslySetInnerHTML={{
      __html: item.data,
    }}
  />
)}
  
          </div>
        );
      })}
    </div>
  ))}
</div>


    </div>
  );
};

export default Detailssection;